import React from "react"
import PropTypes from "prop-types"
import { Magazine } from "@bw/partials"

const MagazineActive = ({
  image,
  title,
  excerpt,
  color,
  pdfUrl,
  paroleUrl,
  subscribeUrl,
}) => {
  return (
    <Magazine
      {...{ image, title, excerpt, color, pdfUrl, paroleUrl, subscribeUrl }}
    />
  )
}

MagazineActive.propTypes = {
  image: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  color: PropTypes.oneOf([
    "art-de-vie",
    "love",
    "bebe",
    "urgence",
    "peau",
    "peach",
    "p-plus",
    "soleil-d-hiver",
    "mentalo",
    "nausee",
    "eau-douce",
    "zen",
  ]).isRequired,
  subscribeUrl: PropTypes.string.isRequired,
  pdfUrl: PropTypes.string.isRequired,
  paroleUrl: PropTypes.string,
}

export { MagazineActive }
